import { createSelector } from 'reselect';

/**
 * Get pending.
 *
 * @author Mikhail Siutsou
 * @function getPending
 * @category Selectors
 * @subcategory Auth
 * @param {AppState} state state.
 * @return {boolean} pending.
 */
var getPending = function getPending(state) {
  return state.auth.pending;
};
/**
 * Get user.
 *
 * @author Mikhail Siutsou
 * @function getUser
 * @category Selectors
 * @subcategory Auth
 * @param {AppState} state state.
 * @return {User | null} current user.
 */


var getUser = function getUser(state) {
  return state.auth.user;
};
/**
 * Get error.
 *
 * @author Mikhail Siutsou
 * @function getError
 * @category Selectors
 * @subcategory Auth
 * @param {AppState} state state.
 * @return {string | null} error.
 */


var getError = function getError(state) {
  return state.auth.error;
};
/**
 * Get auth.
 *
 * @author Mikhail Siutsou
 * @function getAuth
 * @category Selectors
 * @subcategory Auth
 * @param {AppState} state state.
 * @return {AuthUser | null} error.
 */


var getAuth = function getAuth(state) {
  return {};
};

export var getUserSelector = createSelector(getUser, function (user) {
  return user;
});
export var getPendingSelector = createSelector(getPending, function (pending) {
  return pending;
});
export var getErrorSelector = createSelector(getError, function (error) {
  return error;
});
export var getAuthSelector = createSelector(getAuth, function (auth) {
  return auth;
});